import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _excluded = ["assetId", "parentId"],
  _excluded2 = ["data"];
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useQuery } from 'react-query';
import api from 'utils/api';
import getFullUserName from 'utils/getFullUserName';
import getUserInspectorLink from 'utils/getUserInspectorLink';
import isAdmin from 'utils/session/isAdmin';
import assetKeys from './queryKeys';
function fetchAssetActivityLog(_x) {
  return _fetchAssetActivityLog.apply(this, arguments);
}
function _fetchAssetActivityLog() {
  _fetchAssetActivityLog = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref) {
    var assetId, parentId, q, resp;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          assetId = _ref.assetId, parentId = _ref.parentId;
          q = {
            fields: ['created_time', 'action', {
              session: {
                user: ['name', 'id', 'first_name', 'last_name'],
                useragent: ['os_name', 'os_version', 'browser_name']
              }
            }],
            filter: {
              category: 'asset',
              ref_id: assetId,
              session: {
                user: {
                  '-id': null // Ensure User is not null
                }
              }
            },
            orderby: 'created_time DESC',
            limit: 25
          };
          if (parentId) {
            q.filter.asset = {
              parentId: parentId
            };
          }
          _context2.next = 5;
          return api('get', '/api/query/events', q);
        case 5:
          resp = _context2.sent;
          return _context2.abrupt("return", resp.items.map(function (item) {
            var _getFullUserName;
            var user = item.session.user;
            var useragent = item.session.useragent || {};
            var title = (_getFullUserName = getFullUserName(user)) !== null && _getFullUserName !== void 0 ? _getFullUserName : user.name;
            return {
              icon: 'user',
              title: title.trim(),
              tooltip: user.name,
              value: item.created_time,
              device: "".concat(useragent.os_name, " ").concat(useragent.os_version, " ") + "(".concat(useragent.browser_name, ")"),
              link: getUserInspectorLink(user),
              action: item.action
            };
          }));
        case 7:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _fetchAssetActivityLog.apply(this, arguments);
}
function useFetchAssetActivityLog(_ref2) {
  var assetId = _ref2.assetId,
    parentId = _ref2.parentId,
    queryOptions = _objectWithoutProperties(_ref2, _excluded);
  function getAsset() {
    return _getAsset.apply(this, arguments);
  }
  function _getAsset() {
    _getAsset = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", fetchAssetActivityLog({
              assetId: assetId,
              parentId: parentId
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _getAsset.apply(this, arguments);
  }
  var _useQuery = useQuery(assetKeys.assetActivityLogs(assetId, parentId), getAsset, _objectSpread(_objectSpread({}, queryOptions), {}, {
      staleTime: 5 * 60 * 1000,
      enabled: isAdmin()
    })),
    data = _useQuery.data,
    result = _objectWithoutProperties(_useQuery, _excluded2);
  return _objectSpread({
    data: data
  }, result);
}
export default useFetchAssetActivityLog;